import { OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { GlobalService } from '../../services/global.service';
import { ssApiService } from '../../services/ss-api.service';
import { SweetAlertService } from 'ng2-cli-sweetalert2';
import { AddDiscountItemRequest } from '../../../app/models/ss-api/requests/add.discount.item.request';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UserRolesService } from '../../../app/services/user.roles.service';
import { Router } from '@angular/router';

export interface IAddDiscountDialogModel {
    title: string;
    LicenseID?: number;
    MemberID?: number;
}

@Component({
    selector: 'add-discount-dialog',
    styleUrls: ['./add.discount.dialog.css'],
    templateUrl: './add.discount.dialog.html'
})

export class AddDiscountDialog extends DialogComponent<IAddDiscountDialogModel, any> implements IAddDiscountDialogModel, OnInit {
    IsBusy: Boolean = false;
    title: string;
    LicenseID: number;
    MemberID: number;

    DiscountForm: FormGroup;

    constructor(private api: ssApiService, dialogService: DialogService, private gb: GlobalService, private sweetAlert: SweetAlertService, public roles: UserRolesService, public router: Router) {
        super(dialogService, router);
    }

    ngOnInit() {
        this.MemberID = this.LicenseID ? null : this.MemberID;
        this.LicenseID = this.MemberID ? null : this.LicenseID;

        if (this.MemberID != null && this.LicenseID != null) {
            this.sweetAlert.swal({
                type: 'Error',
                title: 'Cannot Add Discount',
                text: 'Cannot add discount to both Member and License. Please choose one or the other.'
            }).then(() => {
                this.close();
            })
        }

        this.DiscountForm = new FormGroup({
            'Amount': new FormControl(0, [Validators.required]),
            'Enabled': new FormControl(true, [Validators.required]),
            'InvoiceDescription': new FormControl('', [Validators.required]),
            'KeepOnZeroInvoice': new FormControl(true, [Validators.required]),
            'LicenseID': new FormControl(this.LicenseID, [Validators.required]),
            'MemberID': new FormControl(this.MemberID, [Validators.required]),
            'Month': new FormControl(1, [Validators.required]),
            'Year': new FormControl(2019, [Validators.required]),
            'Reason': new FormControl(this.MemberID, [Validators.required]),
        })
    }

    confirm() {
        let controls = this.DiscountForm.controls;

        let request: AddDiscountItemRequest = {
            Amount: controls['Amount'].value,
            Enabled: controls['Enabled'].value,
            InvoiceDescription: controls['InvoiceDescription'].value,
            KeepOnZeroInvoice: controls['KeepOnZeroInvoice'].value,
            LicenseID: controls['LicenseID'].value,
            MemberID: controls['MemberID'].value,
            Month: controls['Month'].value,
            Reason: controls['Reason'].value,
            Year: controls['Year'].value
        }

        let disposable = this.api.AddDiscountItem(request).subscribe(response => {
            if (response.Result) {
                this.result = response.Data;
                this.sweetAlert.swal({
                    type: 'success',
                    title: 'Discount Saved',
                    text: 'Discount saved successfully',
                    timer: 1500
                }).then(() => { })
            } else {
                this.sweetAlert.swal({
                    type: 'error',
                    title: 'Discount Not Saved',
                    text: response.Message
                })
            }
            this.close()
            disposable.unsubscribe();
        })
    }

}
